import { graphql } from "relay-runtime"

export const PatientFragment = graphql`
  fragment PatientFragment on Patient {
    __typename
    firstName
    lastName
    id
    patientId
    displayId
    country
    emailAddress
    gender
    birthDate
    address {
      city
      country {
        id
        code: countryIsoCode2
        countryLookupTranslations {
          countryIsoCode2
          countryName
          language
        }
      }
      houseNumberStreet
      postalCode
      countryCode
    }
    primaryLanguage
    secondaryLanguages
    phoneNumber
    age {
      years
      months
      weeks
      days
      isMajor
    }
    patientFileLock {
      ...PatientFileLockFragment
      ...PatientFileLockFragmentInline
    }
    isEligibleForPreventionProgram
    isContactChannelVerified
    contactChannel
  }
`

export const PatientFragmentInline = graphql`
  fragment PatientFragmentInline on Patient @inline {
    __typename
    firstName
    lastName
    id
    displayId
    country
    emailAddress
    gender
    birthDate
    address {
      city
      postalCode
      houseNumberStreet
    }
    primaryLanguage
    secondaryLanguages
    phoneNumber
    age {
      years
      months
      weeks
      days
    }
    patientFileLock {
      ...PatientFileLockFragment
      ...PatientFileLockFragmentInline
    }
    isEligibleForPreventionProgram
  }
`
